import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext, useMemo } from "react";
import { UseFormReturn } from "react-hook-form/dist/types";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import { AutoCompleteOption } from "../../../common/AutoComplete";
import FormInput from "../../../common/FormInput";
import { nameof } from "../../../common/ObjectUtils";
import { ContextDamageForm } from "../../DamageFormContext";
import { DamageFormTypes } from "../../Types";
import dayjs from "dayjs";
import { useHasScope } from "../../../../../../config/globalConfig";

interface Props {
    task1Fields ?: DamageFormTypes.ITask1;
    formInstanceUpdate ?: UseFormReturn<DamageFormTypes.ITask1Update, any>;
};

const EventDetails = (props: Props) => {
    const { rsList } = useContext(ContextDamageForm);
    const damageFormContext = useContext(ContextDamageForm);
    const hasScope = useHasScope;

    const t = useOperationTranslation();

    const repairShopOptions = useMemo<AutoCompleteOption[]>(() => {
        return rsList?.map((opt) => ({
            label: opt.label,
            value: opt.sapId
        })) || [];
    }, []);

    return(
        <Mui.Accordion>
            <Mui.AccordionSummary expandIcon={<MuiIcons.ExpandMore />}>
                <Mui.Typography>
                    {t("damageForm.details.task1.eventDetails.titles.eventDetails")}
                </Mui.Typography>
            </Mui.AccordionSummary>

            <Mui.AccordionDetails>
                <Mui.Grid container spacing={3}>
                    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("lmsTechnicalStop")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.lmsTechnicalStopDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("lmsTechnicalStopEnd")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.lmsTechnicalStopEnd")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("lmsTechnicalStopTimer")}
                            value={props.task1Fields?.lmsTechnicalStopTimer || ""}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.lmsTechnicalStopTimer")}
                            fullWidth
                            disabled
                        />
                        
                    </Mui.Grid>


                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("rescuedBy")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.rescuedBy")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("theftFormCode")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.theftFromCode")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />  
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("misappropriationFormCode")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.missappropFromCode")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />  
                    </Mui.Grid>
                                        
                    
                </Mui.Grid>

                <Mui.Divider style={{marginTop: "20px", marginBottom: "20px"}} />

                <Mui.Typography mb="20px" >
                    {t("damageForm.details.task1.eventDetails.titles.garageQuote")}
                </Mui.Typography>
                
                <Mui.Grid container spacing={3}>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("repairDeliveryDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.garageTakingChargeDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("deliveryDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.garageEndWorkDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("repairTimer")}
                            value={props.task1Fields?.repairTimer || ""}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.garageStopTime")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>              
                   

                    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("repairShopSapId")}
                            formInstance={props.formInstanceUpdate}
                            type="select"
                            options={repairShopOptions}
                            label={t("damageForm.details.task1.eventDetails.labels.garage")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("repairShopAddress")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.garageAddress")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("repairShopCity")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.garageCity")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("repairShopPhone")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.garagePhone")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("repairShopMail")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.garageMail")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("repairShopRepresentative")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.garageContactPerson")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("repairShopNotes")}
                            formInstance={props.formInstanceUpdate}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.garageNote")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("quoteReceivalDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.quoteReceivingDate")}
                            fullWidth
                        />    
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("quoteNegationDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.quoteDenyingDate")}
                            fullWidth
                        />
                    </Mui.Grid>    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("quoteAuthorizationDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.quoteAuthorizationDate")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("replacementOrderDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.partOrderEndingDate")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("replacementUnavailabilityDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.partUnavailabilityStartDate")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("replacementArrivalDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.partReceivingDate")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("repairStartDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.workStartingDate")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("repairEndDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.workEndDate")}
                            fullWidth
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("repairEstimateDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            label={t("damageForm.details.task1.eventDetails.labels.predictedWorkStartDate")}
                            fullWidth
                        />
                    </Mui.Grid>
                    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("tyreType")}
                            value={props.task1Fields?.tyreType}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.tyreSeasonality")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>
              
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("plateLossComplaintDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.plateLostComplaint")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("plateSubstitutionDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.plateSubstitutionDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("plateLossComplaintTimer")}
                            value={props.task1Fields?.plateLossComplaintTimer || ""}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.plateLostComplaintTimer")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>
                    </Mui.Grid>

                <Mui.Divider style={{marginTop: "20px", marginBottom: "20px"}} />
                
                <Mui.Typography mb="20px">
                    {t("damageForm.details.task1.eventDetails.titles.accidentDetails")}
                </Mui.Typography>
            

                <Mui.Grid container spacing={3}>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("seriousDamage")}
                            formInstance={props.formInstanceUpdate}
                            //value={props.task1Fields?.seriousDamage}
                            type="checkbox"
                            label={t("damageForm.details.task1.eventDetails.labels.heavyDamage")}
                            fullWidth
                            onChange={(val: boolean) => {
                                props.formInstanceUpdate?.setValue("seriousDamage", val);
                                if (val === true) {
                                    props.formInstanceUpdate?.setValue("sequestration", false);
                                    props.formInstanceUpdate?.setValue("sequestrationStartDate", null);
                                }
                            }}
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("dismantlingDate")}
                            formInstance={props.formInstanceUpdate}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.demolitionDate")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            maxDateTime={dayjs()}
                        />
                    </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container spacing={3}>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("sequestration")}
                            formInstance={props.formInstanceUpdate}
                            type="checkbox"
                            label={t("damageForm.details.task1.eventDetails.labels.subSeizure")}
                            fullWidth
                            disabled={props.formInstanceUpdate?.watch("seriousDamage") || props.task1Fields?.seriousDamage 
                            || damageFormContext.generalInfo?.migrated ||
                            !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("sequestrationStartDate")}
                            value={props.formInstanceUpdate?.watch("sequestrationStartDate") || null}
                            onChange={(val) => props.formInstanceUpdate?.setValue("sequestrationStartDate", val)}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.subSeizureStartDate")}
                            fullWidth
                            disabled={props.formInstanceUpdate?.watch("seriousDamage")  || props.task1Fields?.seriousDamage
                            || damageFormContext.generalInfo?.migrated ||
                            !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            maxDateTime={dayjs()}
                       />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.ITask1Update>("sequestrationEndDate")}
                            value={props.formInstanceUpdate?.watch("sequestrationEndDate") || null}
                            onChange={(val) => props.formInstanceUpdate?.setValue("sequestrationEndDate", val)}
                            type="date"
                            label={t("damageForm.details.task1.eventDetails.labels.subSeizureEndDate")}
                            fullWidth
                            disabled={props.formInstanceUpdate?.watch("seriousDamage")  || props.task1Fields?.seriousDamage 
                            || damageFormContext.generalInfo?.migrated ||
                            !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                            maxDateTime={dayjs()}
                       />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("sequestrationTimer")}
                            value={props.task1Fields?.sequestrationTimer || ""}
                            type="text"
                            label={t("damageForm.details.task1.eventDetails.labels.subSeizureTimer")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1Update>("legalLetter")}
                            formInstance={props.formInstanceUpdate}
                            type="checkbox"
                            label={t("damageForm.details.task1.eventDetails.labels.lawLetter")}
                            fullWidth
                            disabled={damageFormContext.generalInfo?.migrated ||
                                !hasScope("SCOPE_UPDATE_DAMAGE_TASK_ONE")}
                        />
                    </Mui.Grid>
                    
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("cid")}
                            type="checkbox"
                            value={props.task1Fields?.cid}
                            label={t("damageForm.details.task1.eventDetails.labels.cid")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("mds")}
                            value={props.task1Fields?.mds}
                            type="checkbox"
                            label={t("damageForm.details.task1.eventDetails.labels.den")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.AccordionDetails>
        </Mui.Accordion>
    )
};
export default EventDetails;